/* eslint-disable array-callback-return */
/* eslint-disable no-empty-pattern */
import * as React from 'react';
import { GET_CABINET_PMLC_DATA, TCabinetEntityPmlcData, TGetCabinetDataInput, TGetCabinetPmlcDataOutput } from '../../../../graphql/schema';
import { Divider, Form, Input } from 'antd';
import { AuthContext } from '../../../../context/AuthContext';
import { eUserRole } from '../../../../common/constants';
import TextArea from 'antd/es/input/TextArea';
import { useSubscription } from '@apollo/client';
import { CabinetContext } from '../../../../context/CabinetContext';

interface IMonitorDetailProps {
}

const MonitorDetail: React.FunctionComponent<IMonitorDetailProps> = ({  }) => {
    const { userInfo } = React.useContext(AuthContext)!
    const { selectedDevice } = React.useContext(CabinetContext)!
    const [form] = Form.useForm();
    const [deviceData, setDeviceData] = React.useState<Partial<TCabinetEntityPmlcData>>()
    const { } = useSubscription<TGetCabinetPmlcDataOutput, TGetCabinetDataInput>(GET_CABINET_PMLC_DATA, {
        variables: {
            cabinetDeviceId: selectedDevice!.id
        },
        skip: !selectedDevice?.id,
        onData(d) {
            const result = d.data.data?.getCabinetPmlcData
            if (result) {
                setDeviceData(result)
                form.setFieldsValue({
                    ...result,
                });
            }
        }
    });
    return <>
        <Form
            form={form}
            name="basic"
            wrapperCol={{ span: 24 }}
            className="grid grid-cols-12 gap-2 max-w-[600px]"
            autoComplete="off"
        >
            {deviceData && Object.entries(deviceData).map(([key, value], id) => {
                if (["deviceId", "rawData", "__typename"].includes(key)) return;
                return (
                    <Form.Item className="col-span-3 h-[8px]" label={key} name={key} key={id}>
                        <Input className="w-full" readOnly />
                    </Form.Item>
                )
            })}
            {/* {userInfo && userInfo.user.roleId === eUserRole.SUPPERADMIN && (
                <>
                    <Divider className="col-span-12" />
                    <Form.Item
                        className="col-span-12"
                        label="Dữ liệu thô"
                        name="rawData"
                    >
                        <TextArea className="w-full" rows={8} readOnly />
                    </Form.Item>
                </>
            )} */}
        </Form>
    </>;
};

export default MonitorDetail;
